import { PageHeader } from "@/widgets/page-header"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { 
    BusinessCardsTable,
    CreateBusinessCard,
    fetchBusinessCards, 
    selectBusinessCards, 
    selectBusinessCardsFirstLoad, 
    selectBusinessCardsLoading 
} from "@/entities/business-cards"

export const BusinessCardsPage = () => {
    const cardsFirstLoad = useAppSelector(selectBusinessCardsFirstLoad)
    const dispatch = useAppDispatch()
    const cards = useAppSelector(selectBusinessCards)
    const isLoading = useAppSelector(selectBusinessCardsLoading)
    
    useEffect(() => {
        if (cardsFirstLoad) {
            dispatch(fetchBusinessCards())
        }
    }, [cardsFirstLoad, dispatch])

    const handleCreate = () => {
        dispatch(fetchBusinessCards())
    }

    return (
        <div className="_page_container">
            <PageHeader title="Бизнес-карты" />
            <div className="flexbox">
                <PageSubtitle title="Список карт" />
                <div className="w-full flex justify-end gap-2">
                    <div className="w-full bg-white h-[52px] rounded-full block"/>
                    <CreateBusinessCard onCreate={handleCreate} />
                </div>
                <BusinessCardsTable isLoading={isLoading} cards={cards} />
            </div>
        </div>
    )
}

